
export const jobs = () => []
export const entities = () => []
export const modules = () =>[{
    tKey: 'Logs',
    object: 'SaveLog',
    category: {
        path: 'administrator',
        icon: 'admin'
    },
    newable: false,
    removable: false,
    updatable: false,
    displayLog: false,
    manualFilters: true,
    protectedExport: true,
    viewMap: {
        dt: ['date', 'module', { path: 'user', initiallyNotVisible: true }, {path: 'actionType', tKey: 'action'}, 'identifier'],
        form: [
            {path: 'date', showTime: true, disabled: true},
            {path: 'module', disabled: true},
            {path: 'user', disabled: true},
            {path: 'actionType', tKey: 'action', disabled: true},
            {path: 'identifier', disabled: true},
            {
                path: 'changes',
                type: 'dtObjects',
                autoGrow: true,
                displayTooltip: true,
                fullWidth: true,
                required: true,
                fields: [
                    { path: 'field', tKey: 'element'},
                    { path: 'oldValue'},
                    { path: 'newValue'}
                ]
            },
        ]
    }, filters: ['byPeriod', 'byUsers', 'byModule', 'byUserAction']
}]
